import { render, staticRenderFns } from "./_DesignButtonStylesForm.vue?vue&type=template&id=45df15c8&scoped=true&"
import script from "./_DesignButtonStylesForm.vue?vue&type=script&lang=ts&"
export * from "./_DesignButtonStylesForm.vue?vue&type=script&lang=ts&"
import style0 from "./_DesignButtonStylesForm.vue?vue&type=style&index=0&id=45df15c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45df15c8",
  null
  
)

export default component.exports